import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetTrialItemIdentityByIdRequest,
    type GetTrialItemIdentityByIdResponse,
    type IReturn,
} from "src/api/Tmd.dtos";

const useTrialItemIdentityById = (
    id?: number | null,
    configuration?: SWRConfiguration<
        GetTrialItemIdentityByIdResponse,
        GetTrialItemIdentityByIdResponse
    > | null,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;
        return (): IReturn<GetTrialItemIdentityByIdResponse> =>
            new GetTrialItemIdentityByIdRequest({ id });
    }, [id]);

    return useApi(
        "get",
        getRequest,
        {
            getData: (response?: SWRResponse<GetTrialItemIdentityByIdResponse>) =>
                response?.data?.trialItemIdentity,
            getError: (response?: SWRResponse<GetTrialItemIdentityByIdResponse>) =>
                (response?.error ?? response?.data)?.responseStatus,
            getAdditionalState: () => ({}),
        },
        configuration,
    );
};

export default useTrialItemIdentityById;
